export default "/images/37ff92b3790a3cc3ca632a4c76838672.avif";